export default __webpack_public_path__ + "static/media/InvesterandeMedlemmar.0cd7a3bd.png";